import React, { useContext } from 'react';

import plusCircleTokens from '@amzn/meridian-tokens/base/icon/plus-circle';
import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';

import { useHistory } from 'react-router-dom';
import { CAM_ROLE_SET, EDITOR_ROLE_SET } from 'src/constants/role';
import { ROUTES } from 'src/constants/routes';
import { AppContext } from 'src/contexts/appContext';
import { isOnGammaProd } from 'src/util/config';

interface IButtonGroupForGridProps {
    showAddVendor?: boolean;
    showAddDeal?: boolean;
    showAddPlan?: boolean;
    showAddLaunch?: boolean;
}
export const ButtonGroupForGrid = ({
    showAddVendor = false,
    showAddDeal = false,
    showAddPlan = false,
    showAddLaunch = false
}: IButtonGroupForGridProps) => {
    const { userRole } = useContext(AppContext);
    const history = useHistory();

    return (
        <div className="button-group-for-grid">
            {showAddVendor && (
                <Button
                    type="link"
                    size="small"
                    href={`${ROUTES.VENDORS.INDEX}${ROUTES.VENDORS.ADD}`}
                    onClick={history.push}
                    disabled={!EDITOR_ROLE_SET.has(userRole)}
                >
                    <Icon className="button-icon" tokens={plusCircleTokens} />
                    Add vendor
                </Button>
            )}
            {showAddDeal && (
                <Button
                    type="link"
                    size="small"
                    href={`${ROUTES.DEALS.INDEX}${ROUTES.DEALS.ADD}`}
                    onClick={history.push}
                    disabled={!EDITOR_ROLE_SET.has(userRole)}
                >
                    <Icon className="button-icon" tokens={plusCircleTokens} />
                    Add deals
                </Button>
            )}
            {showAddPlan && (
                <Button
                    type="link"
                    size="small"
                    href={`${ROUTES.PAPER_PLANS.INDEX}${ROUTES.PAPER_PLANS.ADD}${ROUTES.PAPER_PLANS.STEP.SETTINGS}`}
                    onClick={history.push}
                    disabled={!EDITOR_ROLE_SET.has(userRole) || isOnGammaProd()}
                >
                    <Icon className="button-icon" tokens={plusCircleTokens} />
                    Add plan
                </Button>
            )}
            {showAddLaunch && (
                <Button
                    aria-label="showAddLaunch"
                    type="link"
                    size="small"
                    href={`${ROUTES.SERVICE_LAUNCHES.INDEX}${ROUTES.SERVICE_LAUNCHES.ADD}${ROUTES.SERVICE_LAUNCHES.STEP.INPUT}`}
                    onClick={history.push}
                    disabled={!EDITOR_ROLE_SET.has(userRole) || isOnGammaProd()}
                >
                    <Icon className="button-icon" tokens={plusCircleTokens} />
                    Add Launch
                </Button>
            )}
        </div>
    );
};
